var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebuianduxtab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 765 277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-28,.cls-30{fill:none;}.cls-2{isolation:isolate;}.cls-3{fill:#d8c4df;}.cls-25,.cls-29,.cls-31,.cls-4{fill:#2f2143;}.cls-19,.cls-23,.cls-26,.cls-5{fill:#fff;}.cls-6{fill:#9ca1a4;}.cls-7{fill:#2e3133;}.cls-8{fill:#fdc437;}.cls-9{fill:#9a499c;}.cls-10{fill:#b0adad;}.cls-11{fill:#59add1;}.cls-12{fill:#231f20;}.cls-13{mix-blend-mode:darken;}.cls-14{clip-path:url(#clip-path);}.cls-15{clip-path:url(#clip-path-2);}.cls-16{clip-path:url(#clip-path-3);}.cls-17{fill:#82d4f6;}.cls-18{fill:#cbe6ef;}.cls-19{font-size:12.98px;}.cls-19,.cls-23,.cls-25,.cls-26{font-family:Arial-BoldMT, Arial;}.cls-19,.cls-23,.cls-25,.cls-26,.cls-31{font-weight:700;}.cls-20{letter-spacing:-0.07em;}.cls-21{letter-spacing:-0.04em;}.cls-22{letter-spacing:0em;}.cls-23{font-size:12.8px;}.cls-24{letter-spacing:-0.02em;}.cls-25{font-size:25px;}.cls-26{font-size:16px;}.cls-27{fill:#2e1f42;}.cls-28{stroke:#2e1f42;stroke-width:1.27px;}.cls-28,.cls-29,.cls-30{stroke-miterlimit:10;}.cls-29,.cls-30{stroke:#231f20;}.cls-29{stroke-width:1.11px;}.cls-31{font-size:35px;font-family:CenturyGothic-Bold, Century Gothic;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 75.52,
    y: 201.66,
    width: 43.46,
    height: 0.7
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 126.51,
    y: 201.75,
    width: 40.54,
    height: 0.7
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 176.08,
    y: 201.75,
    width: 37.44,
    height: 0.7
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "WEB &amp;amp;UI AND UX TAB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 765,
    height: 277
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M246,212.48H43.58V98.31A10.56,10.56,0,0,1,54.14,87.74H235.41A10.56,10.56,0,0,1,246,98.31Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 50.95,
    y: 95.11,
    width: 187.66,
    height: 113.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M237,228.93H52.55a9,9,0,0,1-9-9v-7.47H246V220a9,9,0,0,1-9,9",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 128.79,
    y: 228.93,
    width: 37.39,
    height: 13.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 120.41,
    y: 242.91,
    width: 52.76,
    height: 3.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M147.48,220.7a2.71,2.71,0,1,1-2.7-2.7,2.7,2.7,0,0,1,2.7,2.7",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 75.52,
    y: 141.97,
    width: 44.01,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 126.26,
    y: 142.06,
    width: 41.05,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 175.61,
    y: 142.06,
    width: 37.91,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 50.95,
    y: 95.11,
    width: 187.66,
    height: 11.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M214.67,102.61H87.78a1.8,1.8,0,1,1,0-3.6H214.67a1.8,1.8,0,1,1,0,3.6",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 218.22,
    y: 99.01,
    width: 8.39,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 228.15,
    y: 99.01,
    width: 8.39,
    height: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M58.67,100.81a1.8,1.8,0,1,1-1.8-1.8,1.8,1.8,0,0,1,1.8,1.8",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M65.42,100.81a1.81,1.81,0,1,1-1.8-1.8,1.8,1.8,0,0,1,1.8,1.8",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72.17,100.81A1.81,1.81,0,1,1,70.36,99a1.8,1.8,0,0,1,1.81,1.8",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M78.91,100.81a1.8,1.8,0,1,1-1.8-1.8,1.79,1.79,0,0,1,1.8,1.8",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 62.75,
    y: 106.51,
    width: 155.47,
    height: 11.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 218.22,
    y: 106.51,
    width: 20.39,
    height: 101.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 50.95,
    y: 106.51,
    width: 20.39,
    height: 101.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 71.33,
    y: 118.04,
    width: 146.89,
    height: 16.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 75.52,
    y: 122.06,
    width: 35.49,
    height: 9.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 119.53,
    y: 128.5,
    width: 14.02,
    height: 3.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 139.58,
    y: 128.5,
    width: 14.02,
    height: 3.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 159.62,
    y: 128.5,
    width: 14.02,
    height: 3.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 179.67,
    y: 128.5,
    width: 14.02,
    height: 3.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 199.72,
    y: 128.5,
    width: 14.02,
    height: 3.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 75.52,
    y: 186.06,
    width: 43.46,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 75.52,
    y: 188.29,
    width: 43.46,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 75.52,
    y: 190.52,
    width: 43.46,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 75.52,
    y: 192.75,
    width: 43.46,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 75.52,
    y: 194.97,
    width: 43.46,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 75.52,
    y: 197.2,
    width: 43.46,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 75.52,
    y: 199.43,
    width: 43.46,
    height: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 75.52,
    y: 201.66,
    width: 43.46,
    height: 0.7
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 126.51,
    y: 186.16,
    width: 40.54,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 126.51,
    y: 188.39,
    width: 40.54,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 126.51,
    y: 190.61,
    width: 40.54,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 126.51,
    y: 192.84,
    width: 40.54,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 126.51,
    y: 195.07,
    width: 40.54,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 126.51,
    y: 197.3,
    width: 40.54,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 126.51,
    y: 199.52,
    width: 40.54,
    height: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 126.51,
    y: 201.75,
    width: 40.54,
    height: 0.7
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 176.08,
    y: 186.16,
    width: 37.44,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 176.08,
    y: 188.39,
    width: 37.44,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 176.08,
    y: 190.61,
    width: 37.44,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 176.08,
    y: 192.84,
    width: 37.44,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 176.08,
    y: 195.07,
    width: 37.44,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 176.08,
    y: 197.3,
    width: 37.44,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 176.08,
    y: 199.52,
    width: 37.44,
    height: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 176.08,
    y: 201.75,
    width: 37.44,
    height: 0.7
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M284.61,100.69l-7.43.71a19.48,19.48,0,0,0-37.78.48c-6.33-1.34-12.31.63-15.19,4.93a13.11,13.11,0,0,0-1.8,6.65,12.8,12.8,0,0,0,12.77,12.76h49.43a12.77,12.77,0,0,0,0-25.53",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M303.75,82.93l-6.08.59a15.95,15.95,0,0,0-30.93.39c-5.18-1.1-10.08.51-12.44,4a10.8,10.8,0,0,0-1.47,5.44,10.49,10.49,0,0,0,10.46,10.45h40.46a10.45,10.45,0,0,0,0-20.9",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M486.33,48.82H404.42A6.38,6.38,0,0,0,397.84,55v5.78a6.38,6.38,0,0,0,6.58,6.16h64.14s8.51,2.78,8.51,10.93c0,0,6.31-6.7,7-10.93h2.27a6.38,6.38,0,0,0,6.58-6.16V55A6.38,6.38,0,0,0,486.33,48.82Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M643.18,102.61H565c-3.47,0-6.28,3.7-6.28,8.26v7.74c0,4.56,2.81,8.26,6.28,8.26h61.18s8.12,3.73,8.12,14.64c0,0,6-9,6.68-14.64h2.16c3.47,0,6.28-3.7,6.28-8.26v-7.74C649.46,106.31,646.65,102.61,643.18,102.61Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M372.1,251.15H314.9c-2.54,0-4.59-2.49-4.59-5.57v-5.21c0-3.08,2.05-5.57,4.59-5.57h42.27s8.69-5.16,8.69-12.52c0,0,4.18,8.7,4.65,12.52h1.59c2.54,0,4.6,2.49,4.6,5.57v5.21C376.7,248.66,374.64,251.15,372.1,251.15Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-19",
    transform: "translate(403.47 62.98)"
  }, "J", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 7.22,
    y: 0
  }, "AV"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 23.33,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 32.23,
    y: 0,
    xmlSpace: "preserve"
  }, " SCRIPT")), /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(328.12 248.44)"
  }, "PH", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 17.78,
    y: 0
  }, "P")), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46.63,58.78h0a10.79,10.79,0,0,0-.11-3.36h0L48,53.33,47,51l-2.57-.24h0a11.18,11.18,0,0,0-2.46-2.29h0l-.4-2.56-2.4-.9-2,1.65v0a10.86,10.86,0,0,0-3.37.12h0l-2.09-1.52-2.33,1-.24,2.58h0a10.78,10.78,0,0,0-2.3,2.46h0l-2.55.41-.9,2.39,1.65,2h0a10.78,10.78,0,0,0,.11,3.36h0L23.63,61.6l1.06,2.34,2.57.24v0a11,11,0,0,0,2.46,2.3h0l.4,2.56,2.4.9,2-1.65v0a10.86,10.86,0,0,0,3.37-.12h0L40,69.66l2.33-1L42.54,66h0a10.58,10.58,0,0,0,2.3-2.46h0l2.55-.41.9-2.39ZM44,60.56a8.74,8.74,0,1,1-5.07-11.27A8.73,8.73,0,0,1,44,60.56",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M532.82,237.69h0a8,8,0,0,0-.08-2.49h0l1.12-1.55-.78-1.72-1.91-.18h0a8,8,0,0,0-1.82-1.7h0l-.3-1.89-1.77-.67-1.48,1.22v0a7.74,7.74,0,0,0-2.5.08h0l-1.55-1.12-1.73.78-.18,1.9h0a8.23,8.23,0,0,0-1.71,1.82h0l-1.89.3-.67,1.77,1.22,1.47h0a8.29,8.29,0,0,0,.08,2.49h0l-1.13,1.55.78,1.73,1.91.17h0a7.76,7.76,0,0,0,1.82,1.7h0l.3,1.89,1.77.67,1.48-1.23h0a8,8,0,0,0,2.49-.09h0l1.54,1.13,1.73-.78.18-1.91h0a8.23,8.23,0,0,0,1.71-1.82h0l1.89-.3.67-1.78Zm-2,1.32a6.47,6.47,0,1,1-3.76-8.34,6.48,6.48,0,0,1,3.76,8.34",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-25",
    transform: "translate(624.09 250.32)"
  }, "&lt;html&gt;"), /*#__PURE__*/React.createElement("text", {
    className: "cls-26",
    transform: "translate(573.27 119.8)"
  }, "&lt;HTML&gt;"), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M701.18,68.71a6.55,6.55,0,1,1-9.11,1.64,6.55,6.55,0,0,1,9.11-1.64",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M734.93,64.5a6.54,6.54,0,1,1-9.11,1.64,6.55,6.55,0,0,1,9.11-1.64",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M704.09,39.18a6.54,6.54,0,1,1-9.1-1.7,6.54,6.54,0,0,1,9.1,1.7",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 697.77,
    y1: 67.56,
    x2: 698.58,
    y2: 49.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-28",
    x1: 697.77,
    y1: 67.56,
    x2: 698.58,
    y2: 49.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 703.72,
    y1: 75.93,
    x2: 725.55,
    y2: 71.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-28",
    x1: 703.72,
    y1: 75.93,
    x2: 725.55,
    y2: 71.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 128.79,
    y1: 40.74,
    x2: 143.26,
    y2: 26.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 123.67,
    y1: 49.46,
    x2: 137.79,
    y2: 35.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 126.97,
    y1: 48.88,
    x2: 153.74,
    y2: 22.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 117.93,
    y1: 60.81,
    x2: 144.7,
    y2: 34.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 133.01,
    y1: 48.95,
    x2: 159.78,
    y2: 22.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 127.95,
    y1: 56.98,
    x2: 154.73,
    y2: 30.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 138.55,
    y1: 49.7,
    x2: 154.01,
    y2: 34.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 132.62,
    y1: 58.57,
    x2: 148.08,
    y2: 43.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 141.83,
    y1: 52.37,
    x2: 147.57,
    y2: 46.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 125.57,
    y1: 41.24,
    x2: 131.31,
    y2: 35.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 342.57,
    y1: 117.53,
    x2: 376.02,
    y2: 84.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 676.96,
    y1: 210.9,
    x2: 704.69,
    y2: 183.17
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-31",
    transform: "translate(371.64 143.01)"
  }, "WEB &amp;", /*#__PURE__*/React.createElement("tspan", {
    x: -105.69,
    y: 38
  }, "APP DEVELOPMENT"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebuianduxtab);
export default __webpack_public_path__ + "static/media/WEB &UI AND UX TAB.147bc6b589ff5f9c0448d9aac75d958f.svg";
export { ForwardRef as ReactComponent };